import styled from 'styled-components';

const Wrapper = styled.div`
  display: flex;
`;

const ImageWrapper = styled.div`
  width: 12.5rem;
  height: 8.7rem;
`;

const DownloadLink = styled.a`
  display: block;
  width: 100%;
  height: 100%;
  text-decoration: none;
`;

const Titles = styled.div`
  padding: 2.5rem;
`;

export { Wrapper, ImageWrapper, DownloadLink, Titles };
